module.exports = __webpack_public_path__ + "static/media/main-logo.2411ee9b.png";